import { BrandJustLogo } from "@hl/base-components/lib/assets/icons.generated";
import { Center, Footer } from "@mantine/core";

export const AppFooter: React.FC = ({}) => (
  <Footer
    mt="md"
    height="auto"
    p="md"
    withBorder={false}
    sx={{ position: "relative" }}
  >
    <Center>
      <BrandJustLogo height={12} />
    </Center>
  </Footer>
);
